export const reviews = [
  {
    id: 1,
    name: '小雨',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%20with%20warm%20smile%20natural%20look%20soft%20lighting%20simple%20cream%20background%20professional%20headshot%20style%20clean%20minimal%20aesthetic&width=120&height=120&seq=avatar-01&orientation=squarish',
    identity: '忠实读者 · 阅读3年',
    rating: 5,
    content: '这个网站真的太棒了！更新速度很快，翻译质量也非常高。我追的好几部漫画在这里都能第一时间看到最新一话，而且完全免费！界面设计也很舒服，用手机看漫画特别方便。',
  },
  {
    id: 2,
    name: '小明爱吃瓜',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20man%20portrait%20friendly%20expression%20casual%20style%20soft%20natural%20lighting%20simple%20cream%20background%20professional%20headshot%20clean%20minimal&width=120&height=120&seq=avatar-02&orientation=squarish',
    identity: '漫画深度爱好者',
    rating: 5,
    content: '作为一个看了十年韩漫的老读者，我必须说这里的资源真的很全。从经典老番到最新连载，各种类型都有。分类也很清晰，找漫画特别快。已经推荐给好多朋友了！',
  },
  {
    id: 3,
    name: '喵喵追漫中',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%20cute%20gentle%20smile%20soft%20natural%20lighting%20simple%20cream%20background%20professional%20headshot%20style%20minimal%20clean&width=120&height=120&seq=avatar-03&orientation=squarish',
    identity: '恋爱漫画控',
    rating: 5,
    content: '我最爱的恋爱漫画这里全都有！而且还有好多好看的冷门作品。每天晚上睡前必刷，已经成为我的日常习惯了。推荐列表也特别懂我，经常能发现宝藏漫画！',
  },
  {
    id: 4,
    name: '二次元宅男',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20man%20portrait%20casual%20friendly%20look%20natural%20lighting%20simple%20cream%20background%20professional%20headshot%20clean%20minimal%20style&width=120&height=120&seq=avatar-04&orientation=squarish',
    identity: '奇幻漫画达人',
    rating: 5,
    content: '地下城勇士和魔法厨神这种奇幻类型的漫画在这里最全！一口气能追好几部，而且没有广告骚扰。网站的加载速度也很快，翻页很流畅。真心推荐给所有喜欢韩漫的朋友！',
  },
] as const;

export const stats = [
  { label: '收录漫画', value: '5,000+' },
  { label: '累计章节', value: '150,000+' },
  { label: '月活用户', value: '200万+' },
  { label: '日更新量', value: '300+' },
] as const;